module.exports = __webpack_public_path__ + "static/media/title-desktop.9149694e.png";